import { isString } from 'formik';
import { ENVIRONMENT_KEYS } from '../constants';
import { currentEnvironment } from '../services/Environment';

class Logger {
  constructor(logger = console) {
    this.logger = logger;
  }

  setLoggerName(loggerName) {
    this.loggerName = loggerName;
  }

  create({ loggerName }) {
    const newLogger = new Logger(this);
    newLogger.setLoggerName(loggerName);
    return newLogger;
  }

  init(logger) {
    if (currentEnvironment() === ENVIRONMENT_KEYS.DEVELOPMENT) return;

    this.logger = logger || console;
  }

  info(message, ...args) {
    this.logger.info(this._parseMessage(message), ...args);
  }

  log(message, ...args) {
    this.info(message, ...args);
  }

  error(message, ...args) {
    this.logger.error(this._parseMessage(message), ...args);
  }

  debug(message, ...args) {
    this.logger.debug(this._parseMessage(message), ...args);
  }

  warn(message, ...args) {
    this.logger.warn(this._parseMessage(message), ...args);
  }

  _parseMessage(message) {
    if (isString(message) && this.loggerName) {
      return `[${this.loggerName}] ${message}`;
    }
    return message;
  }
}

export default new Logger();
